import { BTaxBill } from 'egov-api';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'btax-bill-paid',
    template: `
        <ng-container *ngIf="bill">
            {{ bill.amountPaid | currency }}
        </ng-container>
        <egov-text-ui-placeholder *ngIf="!bill" length="6"></egov-text-ui-placeholder>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BTaxBillPaidComponent
{
    @Input() protected bill?: BTaxBill;
}
